/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-06 10:19:42
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-06 10:32:24
 * @FilePath: /dbrank_b/src/routes/cms/components/BrandTag/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Tag.css';
import classNames from 'classnames';

class BrandTag extends React.Component {
  onClick = () => {
    const { onClick } = this.props;
    typeof onClick === 'function' && onClick()
  }

  render() {
    const { className, children, close } = this.props;
    return(
      <span className={classNames(s.root, className)} onClick={this.onClick}>
        {children}
        {close && <i className={s.close}>✖</i>}
      </span>
    )
  }
}

export default withStyles(s)(BrandTag);



// WEBPACK FOOTER //
// src/routes/cms/components/BrandTag/index.js